import { Navigate, useLocation, useParams } from 'react-router';

interface LegacyRedirectProps {
  /** Nová cesta bez koncového lomítka, napríklad `/podnety`. */
  to: string;
}

/**
 * Presmerovanie zo starých adries s `ohlasenia` na dnešné s `podnety`.
 *
 * Odkazy na podnety chodia z e-mailov a z push notifikácií, ktoré sú
 * rozposlané a neprepíšeme ich - a odkaz, ktorý občanovi ukáže 404 na jeho
 * vlastný podnet, je horší než štyri riadky navyše v smerovacej tabuľke.
 * Zvyšok cesty aj dopyt sa nesú ďalej nezmenené, takže `ohls:` identifikátor
 * v nich dorieši `entityId` z [[ids]].
 *
 * Routy, ktoré sem vedú, sú v [[App]] označené komentárom; nemažte ich bez
 * toho, aby ste vedeli, že najstaršie notifikácie sú už neaktuálne.
 */
const LegacyRedirect = ({ to }: LegacyRedirectProps) => {
  const rest = useParams()['*'];
  const { search, hash } = useLocation();

  return (
    <Navigate replace to={`${to}${rest ? `/${rest}` : ''}${search}${hash}`} />
  );
};

export default LegacyRedirect;
